const SPECS_FIELDS = [
    {field: 'Quantity', label: 'QUANTITY'},
    {field: 'ProductHeight', label: 'HEIGHT'},
    {field: 'ProductWidth', label: 'WIDTH'},
    {field: 'ProductLeftWidth', label: 'LEFT WIDTH'},
    {field: 'ProductRightWidth', label: 'RIGHT WIDTH'},
    {field: 'ProductWidthDoor1', label: 'DOOR 1 WIDTH'},
    {field: 'ProductWidthDoor2', label: 'DOOR 2 WIDTH'},
    {field: 'ProductDepth', label: 'DEPTH'},
    {field: 'ProductLeftDepth', label: 'LEFT DEPTH'},
    {field: 'ProductRightDepth', label: 'RIGHT DEPTH'},
    {field: 'ProductLength', label: 'LENGTH'},
    {field: 'KickWidth', label: 'KICK WIDTH'},
    {field: 'KickDepth', label: 'KICK DEPTH'},
    {field: 'KickHeight', label: 'KICK HEIGHT'},
    {field: 'LadderFrames', label: 'LADDER FRAMES'},
    {field: 'FinishAtCabBottom', label: 'FINISH AT CAB BOTTOM'},
    {field: 'DoorDwrProductName', label: 'STYLE'}, // common for Door and Drawer
];

const HARDWARE_FIELDS = [
    {
        field: 'AdjustableLegs',
        label: 'ADJUSTABLE LEGS',
        conditions: [
            {
                value: 'None',
                expression: 'AdjustableLegs = 0',
            },
            {
                value: 'Drilling Only',
                expression: 'AND(AdjustableLegs = 1, ExcludeHardware = 1)',
            },
            {
                value: 'Supplied',
                expression: 'AND(AdjustableLegs = 1, ExcludeHardware = 0)',
            },
        ],
    },
    {field: 'AssemblyNeeded', label: 'PRODUCT SUPPLY'},
    {
        field: 'ExcludeHardware',
        label: 'SUPPLY HARDWARE',
        conditions: [
            {
                value: 'No, Drilling Only',
                expression: 'ExcludeHardware = 1',
            },
            {
                value: 'Yes',
                expression: 'ExcludeHardware = 0',
            },
        ],
    },
];

const EXTERIOR_FIELDS = [
    {field: 'ExteriorMaterial', label: 'MATERIAL'},
    {field: 'ExteriorEdging', label: 'EDGING'},
];

const FRAME_FIELDS = [{field: 'FrameMaterial', label: 'MATERIAL'}];

const PANEL_FIELDS = [
    {field: 'PanelMaterial', label: 'MATERIAL'},
    {field: 'PanelEdging', label: 'EDGING'},
];

const PARTITIONS_FIELDS = [
    {field: 'HorizontalPartitions', label: 'HORIZONTAL'},
    {field: 'VerticalPartitions', label: 'VERTICAL'},
];

const FACE_FIELDS = [
    {field: 'BackFace', label: 'BACK'},
    {field: 'FrontFace', label: 'FRONT'},
    {field: 'LeftFace', label: 'LEFT'},
    {field: 'RightFace', label: 'RIGHT'},
];

const INTERIOR_FIELDS = [
    {field: 'InteriorMaterial', label: 'MATERIAL'},
    {field: 'InteriorEdging', label: 'EDGING'},
];

const DOOR_DRAWER_EDGING_FIELDS = [
    {field: 'DoorDwrEdgingTop', label: 'TOP'},
    {field: 'DoorDwrEdgingBottom', label: 'BOTTOM'},
    {field: 'DoorDwrEdgingLeft', label: 'LEFT'},
    {field: 'DoorDwrEdgingRight', label: 'RIGHT'},
];

const DETAIL_FIELDS = [
    {field: 'DrawerImage', label: 'STYLE', type: 'image'},
    {field: 'DoorDwrProductName', label: 'STYLE'},
    {field: 'DrawerAmount', label: 'AMOUNT'},
    {field: 'DrawerFaceType', label: 'FACE TYPE'},
    {field: 'OvenLocation', label: 'TOTAL HEIGHT'},
];

const DOOR_FIELDS = [
    {field: 'DoorImage', label: 'STYLE', type: 'image'},
    {field: 'DoorDwrProductName', label: 'STYLE'},
    {field: 'DoorAmount', label: 'AMOUNT'},
    {field: 'SpecificHingeHeights', label: 'HINGE QUANTITY PER DOOR'},
    {field: 'HingeSeries', label: 'HINGE SERIES'},
    {field: 'DoorHang', label: 'HANG'},
    {field: 'UpperDoorHang', label: 'HANG'},
    {field: 'DoorHangType', label: 'HANG TYPE'},
];

const DOOR_TOP_FIELDS = [
    {field: 'SpecificHingeHeightsTop', label: 'HINGE HEIGHT TOP'},
];

const DOOR_BOTTOM_FIELDS = [
    {field: 'SpecificHingeHeightsBottom', label: 'HINGE HEIGHT BOTTOM'},
];

const SHELVES_FIELDS = [
    {field: 'Section1Shelves', label: 'SHELVES'},
    {field: 'Shelves', label: 'SHELVES'},
    {field: 'Section1SetBack', label: 'SET BACK'},
    {field: 'PartSetback', label: 'PART SET BACK'},
    {field: 'Section1ShelvesDrilling', label: 'DRILLING'},
    {field: 'ShelvesDrilling', label: 'DRILLING'},
];

const PANEL_EDGE_FIELDS = [
    {field: 'Panel Edge Top', label: 'TOP'},
    {field: 'Panel Edge Bottom', label: 'BOTTOM'},
    {field: 'Panel Edge Left', label: 'LEFT'},
    {field: 'Panel Edge Right', label: 'RIGHT'},
];

const DRAWER_PANEL_EDGE_FIELDS = [
    {field: 'Drawer Panel Edge Top', label: 'TOP'},
    {field: 'Drawer Panel Edge Bottom', label: 'BOTTOM'},
    {field: 'Drawer Panel Edge Left', label: 'LEFT'},
    {field: 'Drawer Panel Edge Right', label: 'RIGHT'},
    {field: 'Drawer Panel Edge Inner', label: 'INNER'},
];

const EDGE_FIELDS = [
    {field: 'EdgeFront', label: 'FRONT'},
    {field: 'EdgeBack', label: 'BACK'},
    {field: 'EdgeTop', label: 'TOP'},
    {field: 'EdgeBottom', label: 'BOTTOM'},
    {field: 'EdgeLeft', label: 'LEFT'},
    {field: 'EdgeRight', label: 'RIGHT'},
];

const EXTERIOR_EDGE_FIELDS = [
    {field: 'ExteriorEdgeFront', label: 'FRONT'},
    {field: 'ExteriorEdgeBack', label: 'BACK'},
    {field: 'ExteriorEdgeLeft', label: 'LEFT'},
    {field: 'ExteriorEdgeRight', label: 'RIGHT'},
];

const BORDER_WIDTH_FIELDS = [
    {field: 'Border Width Top', label: 'TOP'},
    {field: 'Border Width Bottom', label: 'BOTTOM'},
    {field: 'Border Width Left', label: 'LEFT'},
    {field: 'Border Width Right', label: 'RIGHT'},
];

const DRAWER_BORDER_WIDTH_FIELDS = [
    {field: 'Drawer Border Width Top', label: 'TOP'},
    {field: 'Drawer Border Width Bottom', label: 'BOTTOM'},
    {field: 'Drawer Border Width Left', label: 'LEFT'},
    {field: 'Drawer Border Width Right', label: 'RIGHT'},
    {field: 'Drawer Joining Border Width', label: 'JOINING'},
];

const HORIZONTAL_BARS_FIELDS = [
    {field: 'Horizontal Bar Amount', label: 'AMOUNT'},
    {field: 'Hoizontal Bar Height', label: 'HEIGHT'},
    {field: 'Horizontal Bar 1 Position', label: 'POSITION 1'},
    {field: 'Horizontal Bar 2 Position', label: 'POSITION 2'},
    {field: 'Horizontal Bar 3 Position', label: 'POSITION 3'},
    {field: 'Horizontal Bar 4 Position', label: 'POSITION 4'},
    {field: 'Horizontal Bar 5 Position', label: 'POSITION 5'},
];

const VERTICAL_BARS_FIELDS = [
    {field: 'Vertical Bar Amount', label: 'AMOUNT'},
    {field: 'Vertical Bar Height', label: 'HEIGHT'},
    {field: 'Vertical Bar 1 Position', label: 'POSITION 1'},
    {field: 'Vertical Bar 2 Position', label: 'POSITION 2'},
    {field: 'Vertical Bar 3 Position', label: 'POSITION 3'},
    {field: 'Vertical Bar 4 Position', label: 'POSITION 4'},
];

const GLASS_CUTOUT_FIELDS = [
    {field: 'Top Glass sub Left Panel', label: 'TOP LEFT'},
    {field: 'Top Glass sub Centre Panel', label: 'TOP CENTRE'},
    {field: 'Top Glass sub Right Panel', label: 'TOP RIGHT'},
    {field: 'Centre Glass sub Left Panel', label: 'CENTRE LEFT'},
    {field: 'Centre Glass sub Panel', label: 'CENTRE'},
    {field: 'Centre Glass sub Right Panel', label: 'CENTRE RIGHT'},
    {field: 'Bottom Glass sub Left Panel', label: 'BOTTOM LEFT'},
    {field: 'Bottom Glass sub Centre Panel', label: 'BOTTOM CENTRE'},
    {field: 'Bottom Glass sub Right Panel', label: 'BOTTOM RIGHT'},
];

const CLEARANCE_FIELDS = [
    {field: 'BaseTopClearance', label: 'BASE TOP'},
    {field: 'BaseBottomClearance', label: 'BASE BOTTOM'},
    {field: 'BaseLeftSideClearance', label: 'BASE LEFT'},
    {field: 'BaseRightSideClearance', label: 'BASE RIGHT'},
    {field: 'TallTopClearance', label: 'TOP'},
    {field: 'TallBottomClearance', label: 'BOTTOM'},
    {field: 'TallLeftSideClearance', label: 'LEFT'},
    {field: 'TallRightSideClearance', label: 'RIGHT'},
    {field: 'UpperTopClearance', label: 'TOP'},
    {field: 'UpperBottomClearance', label: 'BOTTOM'},
    {field: 'UpperLeftSideClearance', label: 'LEFT'},
    {field: 'UpperRightSideClearance', label: 'RIGHT'},
    {field: 'ClearanceBetweenDrawers', label: 'BETWEEN DRAWERS'},
    {field: 'VerticalClearanceBetweenDoors', label: 'BETWEEN DOORS'},
];

const OVEN_FIELDS = [
    {field: 'SingleOvenSize', label: 'SIZE'},
    {field: 'SingleOvenName', label: 'NAME'},
    {field: 'SingleOvenModel', label: 'MODEL'},
    {field: 'OvenTypeSize', label: 'SIZE'},
    {field: 'OvenTypeName', label: 'NAME'},
    {field: 'OvenTypeModel', label: 'MODEL'},
];

const MICROWAVE_FIELDS = [
    {field: 'MicrowaveTypeSize', label: 'SIZE'},
    {field: 'MicrowaveTypeName', label: 'NAME'},
    {field: 'MicrowaveTypeModel', label: 'MODEL'},
];

const RANGEHOOD_FIELDS = [
    {field: 'RangehoodTypeSize', label: 'SIZE'},
    {field: 'RangehoodTypeName', label: 'BRAND'},
    {field: 'RangehoodTypeModel', label: 'MODEL'},
];

const TOP_SHELVES_FIELDS = [
    {field: 'TopShelves', label: 'SHELVES'},
    {field: 'ShelfSetbackTopSection', label: 'SHELF SETBACK'},
    {field: 'TopShelvesDrilling', label: 'DRILLING'},
];

const MIDDLE_SHELVES_FIELDS = [
    {field: 'MiddleShelves', label: 'SHELVES'},
    {field: 'ShelfSetbackMiddleSection', label: 'SHELF SETBACK'},
    {field: 'MiddleShelvesDrilling', label: 'DRILLING'},
];

const BOTTOM_SHELVES_FIELDS = [
    {field: 'BottomShelves', label: 'SHELVES'},
    {field: 'ShelfSetbackBottomSection', label: 'SHELF SETBACK'},
    {field: 'BottomShelvesDrilling', label: 'DRILLING'},
];

const LEFT_SHELVES_FIELDS = [
    {field: 'BottomShelvesLeft', label: 'SHELVES'},
    {field: 'ShelfSetbackLeftSection', label: 'SHELF SETBACK'},
    {field: 'BottomShelvesLeftDrilling', label: 'DRILLING'},
    {field: 'BottomLeftShelves', label: 'SHELVES'},
    {field: 'BottomLeftShelvesDrilling', label: 'DRILLING'},
];

const RIGHT_SHELVES_FIELDS = [
    {field: 'BottomShelvesRight', label: 'SHELVES'},
    {field: 'ShelfSetbackRightSection', label: 'SHELF SETBACK'},
    {field: 'BottomShelvesRightDrilling', label: 'DRILLING'},
];

const SHELF_MATERIAL_FIELDS = [
    {field: 'FixedShelfMaterial', label: 'FIXED'},
    {field: 'AdjustableShelfMaterial', label: 'ADJUSTABLE'},
];

const ADDITIONAL_MEASUREMENT_FIELDS = [
    {field: 'HorizontalPartitionHeight', label: 'HORIZONTAL PARTITION HEIGHT'},
    {field: 'VerticalPartitionLocation', label: 'VERTICAL PARTITION LOCATION'},
];

const OTHER_FIELDS = [
    // ALL OTHER FIELDS THAT WE WANT TO DISPLAY SHOULD BE ADDED HERE
    // WHITELISTING SO WE DON'T DISPLAY FIELDS UNEXPECTEDLY
    {field: 'TotalHeight', label: 'TOTAL HEIGHT'},
    {field: 'TopChoice', label: 'TOP CHOICE'},
    {field: 'DrawerFrontHeight', label: 'DRAWER FRONT HEIGHT'},
    {field: 'EdgeJoiningBorder', label: 'EDGE JOINING BORDER'},
    {field: 'LeftEndButts', label: 'LEFT END BUTTS'},
    {field: 'RightEndButts', label: 'RIGHT END BUTTS'},
    {field: 'HorizontalPartition', label: 'HORIZONTAL PARTITION'},
    {field: 'VerticalPartition', label: 'VERTIAL PARTITION'},
    {field: 'RecessedHandleOption', label: 'RECESSED HANDLE OPTION'},
    {field: 'Mirrored', label: 'MIRRORED'},
    {field: 'DepthLeft', label: 'DEPTH LEFT'},
    {field: 'DepthRight', label: 'DEPTH RIGHT'},
    {field: 'ExternalRadius', label: 'EXTERNAL RADIUS'},
    {field: 'InternalRadius', label: 'INTERNAL RADIUS'},
    {field: 'InteriorEdgeFront', label: 'INTERIOR EDGE FRONT'},
    {field: 'InteriorEdgeBack', label: 'INTERIOR EDGE BACK'},
    {field: 'InteriorEdgeLeft', label: 'INTERIOR EDGE LEFT'},
    {field: 'InteriorEdgeRight', label: 'INTERIOR EDGE RIGHT'},
    {field: 'InsideRadius', label: 'INTERNAL RADIUS'},
    {field: 'EdgeRightWidth', label: 'EDGE RIGHT WIDTH'},
    {field: 'EdgeLeftWidth', label: 'EDGE LEFT WIDTH'},
    {field: 'EdgeRightDepth', label: 'EDGE RIGHT DEPTH'},
    {field: 'EdgeLeftDepth', label: 'EDGE LEFT DEPTH'},
    {field: 'EdgeShape', label: 'EDGE SHAPE'},
];

const VARIATIONS = [
    {field: 'VariationRequest', label: 'REQUEST'},
    {field: 'VariationName', label: 'VARIATION NAME'},
    {field: 'Comments', label: 'CUSTOMER NOTE'},
];

export default [
    {header: 'SPECS', fields: SPECS_FIELDS},
    {header: 'VARIATIONS', fields: VARIATIONS},
    {header: 'HARDWARE', fields: HARDWARE_FIELDS},
    {header: 'EXTERIOR', fields: EXTERIOR_FIELDS},
    {header: 'FRAME', fields: FRAME_FIELDS},
    {header: 'PANEL', fields: PANEL_FIELDS},
    {header: 'PARTITIONS', fields: PARTITIONS_FIELDS},
    {header: 'FACE', fields: FACE_FIELDS},
    {header: 'INTERIOR', fields: INTERIOR_FIELDS},
    {header: 'DOOR DRAWER EDGING', fields: DOOR_DRAWER_EDGING_FIELDS},
    {header: 'DRAWER EDGING', isCustom: true},
    {header: 'DRAWER', fields: DETAIL_FIELDS},
    {header: 'DRAWER DETAIL', isCustom: true},
    {header: 'DOOR', fields: DOOR_FIELDS},
    {header: 'DOOR TOP', fields: DOOR_TOP_FIELDS},
    {header: 'DOOR BOTTOM', fields: DOOR_BOTTOM_FIELDS},
    {header: 'OVEN', fields: OVEN_FIELDS},
    {header: 'MICROWAVE', fields: MICROWAVE_FIELDS},
    {header: 'RANGEHOOD', fields: RANGEHOOD_FIELDS},
    {header: 'TOP SHELVES', fields: TOP_SHELVES_FIELDS},
    {header: 'MIDDLE SHELVES', fields: MIDDLE_SHELVES_FIELDS},
    {header: 'BOTTOM SHELVES', fields: BOTTOM_SHELVES_FIELDS},
    {header: 'SHELVES LEFT SECTION', fields: LEFT_SHELVES_FIELDS},
    {header: 'SHELVES RIGHT SECTION', fields: RIGHT_SHELVES_FIELDS},
    {header: 'SHELVES', fields: SHELVES_FIELDS},
    {header: 'SHELF MATERIAL', fields: SHELF_MATERIAL_FIELDS},
    {header: 'ADDITIONAL MEASUREMENT', fields: ADDITIONAL_MEASUREMENT_FIELDS},
    {header: 'CLEARANCE', fields: CLEARANCE_FIELDS},
    {header: 'EDGE', fields: EDGE_FIELDS},
    {header: 'BORDER WIDTH', fields: BORDER_WIDTH_FIELDS},
    {header: 'DRAWER BORDER WIDTH', fields: DRAWER_BORDER_WIDTH_FIELDS},
    {header: 'EXTERIOR EDGE', fields: EXTERIOR_EDGE_FIELDS},
    {header: 'PANEL EDGE', fields: PANEL_EDGE_FIELDS},
    {header: 'DRAWER PANEL EDGE', fields: DRAWER_PANEL_EDGE_FIELDS},
    {header: 'HORIZONTAL BARS', fields: HORIZONTAL_BARS_FIELDS},
    {header: 'VERTICAL BARS', fields: VERTICAL_BARS_FIELDS},
    {header: 'CUTOUT FOR GLASS', fields: GLASS_CUTOUT_FIELDS},
    {header: 'DRILLING', isCustom: true},
    {header: 'OTHER SPECS', fields: OTHER_FIELDS},
];
